// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"a6b3ddd8","578":"e96e0441","711":"56fa9d5d","798":"d2cd906a"}[chunkId] + ".chunk.js";
};